import React, {FC, useState, useEffect, useRef} from "react";
import { useTranslation } from "react-i18next";
import {
  Container,
  SearchWrapper,
  ImgArrow,
  OptionsWrapper,
  SearchInput,
  Title,
  IconWrapper,
  Divider,
  SearchResultsContainer,
  DividerCategory,
  DropOptionsTitle,
  DropItemWrapper,
  DropOptionItem,
} from './styles'
import algoliasearch from 'algoliasearch';
import { InstantSearch, SearchBox, Hits } from 'react-instantsearch-dom';
import useDebounce from "../../hooks/useDebounce";
import { transformHitsToCategories } from "../../utils/search-response-handler";
import SearchResultIcon from './search-result-icon'
import FigmaSearchIcon from './figma-search.svg'
import FigmaSearchDarkIcon from './figma-search-dark.svg'
import FigmaCloseIcon from './figma-close.svg'
import FigmaCloseDarkIcon from './figma-close-dark.svg'
import { useUi } from '../../context/ui.context'


// const AlgoliaClient = axios.create({
//   // baseURL: `${config.apiUrl}api/`,
//   // baseURL: 'https://core.ocplanet.cloud/backend/api/',
//   baseURL:`https://NQO6IXTPQW.algolia.net/1/indexes/a96759f341966142e7b893daa53a61a1/facets/facetName/query`,
//   withCredentials: true,
//   headers: {
//     'X-Algolia-Application-Id':'NQO6IXTPQW',
//     'X-Algolia-API-Key':'a96759f341966142e7b893daa53a61a1'
//     // 'Access-Control-Allow-Headers': "Cookie, Set-Cookie",
//   }
// });

const searchClient = algoliasearch('NQO6IXTPQW', 'a96759f341966142e7b893daa53a61a1')
type SearchProps = {
  searchString?:string
}

const SearchComponent:FC<SearchProps> = () => {
  const index = searchClient.initIndex('onecloudplanet')
  const selectRef:any = useRef()
  const [active, setActive] = useState<boolean>(false)
  const [search, setSearch] = useState<string>('')
  const [hits, setHits] = useState<any[]>([])
  const [activeResults, setActiveResults] = useState<boolean>(false)
  const [t] = useTranslation()
  const {themeDark} = useUi()
  const openSearch = () => {
    setActive(true)
    setActiveResults(true)
  }
  useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
				document.removeEventListener('click', handleClickOutside, true);
		};
  },[]);

  const handleClickOutside = (event:any) => {
    if (selectRef?.current && !selectRef.current.contains(event.target)){
      setActive(false)
      setActiveResults(false)
    }
  }

  const requestOptions:any = {
    headers:{

    },
    // queryParameters:{
      hitsPerPage: 100,
      facetFilters: [`language:${localStorage.getItem('lang') === 'uk' ? 'ua' : 'en'}`],
    // }
  }
  const debounce = useDebounce(search, 500)
  const searchFunc = () => {
    index
    .search(search, requestOptions)
    .then(({ hits }) => setHits(transformHitsToCategories(hits)))
  }
  useEffect(() => {
    searchFunc()

  },[debounce])

  return (
    <Container data-test-id='search-component' active={active}>
      <SearchWrapper onClick={openSearch} data-test-id='search-input-container' activeResults={activeResults} active={active} >
        <div style={{display:'flex', width:'100%', minWidth:0, alignItems:'center'}}>
          <IconWrapper>
            <img src={themeDark ? FigmaSearchDarkIcon : FigmaSearchIcon} alt="" aria-hidden="true"/>
            <Title>
              {t("SEARCH")}
            </Title>
          </IconWrapper>
          <SearchInput
            autoComplete="off"
            name="ocp-global-search"
            data-1p-ignore="true"
            data-lpignore="true"
            placeholder={`${t("PRODUCTS_SERVICES_DOCS")}`}
            onClick={(event:any) => {
              event.stopPropagation()
              openSearch()
            }}
            active={active}
            value={search}
            onChange={(event:any) => {
              const modalOpen = document.querySelector('#modalContainer[data-open="true"]')
              if (modalOpen || document.activeElement !== event.currentTarget) {
                event.currentTarget.value = search
                return
              }
              setSearch(event.currentTarget.value)
            }}
          />
        </div>
        {active ? 
            <ImgArrow
              src={themeDark ? FigmaCloseDarkIcon : FigmaCloseIcon}
              onClick={(event:any) => {
                event.stopPropagation()
                setActive(false)
                setActiveResults(false)
              }}
            />
        :
          null
        }
      </SearchWrapper>
      <SearchResultsContainer data-test-id='search-results-container' active={activeResults}>
        <Divider active={activeResults}/>
        <OptionsWrapper ref={selectRef} active={activeResults}>
          {hits.map((hit:any, index:any) => (
            <React.Fragment key={hit.title || index}>
                <DropOptionsTitle>
                  {hit.title}
                </DropOptionsTitle>
              {hit.value.map((product:any, productIndex:any) => (
                <DropItemWrapper key={`${hit.title}-${product.url || product.title}-${productIndex}`} onClick={() => window.open(product.url)}>
                  <SearchResultIcon
                    product={product}
                    categoryTitle={hit.title}
                    dataTestId={index === 0 && productIndex === 0 ? 'search-document-icon' : undefined}
                  />
                  <DropOptionItem>
                    {product.title}
                  </DropOptionItem>
                  
                </DropItemWrapper>
              ))}
              {index !== hits.length-1 &&
                <DividerCategory/>
              }
            </React.Fragment>
          ))}
        </OptionsWrapper>
      </SearchResultsContainer>
    </Container>
  )
}

export default SearchComponent
